import { render } from "./EnMenu.vue?vue&type=template&id=8a2d470a&scoped=true"
const script = {}

import "./EnMenu.vue?vue&type=style&index=0&id=8a2d470a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2d470a"]])

export default __exports__